import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPassportData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FileUploadElement from "../../../../ReusableComponents/UploadFile/uplaodFile";
import ListPassportRenwal from "./ListPassportRenewal";
import nodeinstance from "../../../../nodeInstance";

export default function PassportRenewal() {
  const data = useSelector((state) => state.passportData);
  const dispatch = useDispatch();

  //screen Title Show fun
  const titleBorder = [
    { label: "Passport Renewal", link: "/dashboard/AtmPayroll" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

 

  // useEffect(() => {
  //   dispatch(getPassportData(token));
  // }, []);

  // const updateData = () => {
  //   dispatch(getPassportData(token));
  // };

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  const uploadFile = async (file) => {
    console.log(file);
    if (file) {
      setLoading((p) => ({ ...p, loadingId: file }));
      try {
        const response = await axios.get(
          `/employees/updateBorderNumbersFromExcel/${file}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          apiCall();
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  console.log("Data to be seen in the page")
  return (
    <>
      {showPromptElement.open && (
        <FileUploadElement
          title={"Upload Tamplate with Border Number"}
          subTitle={"Upload templete"}
          showFileUploadElement={showPromptElement}
          setShowFileUploadElement={setShowPromptElement}
          uploadFile={uploadFile}
        />
      )}
      <div className={`ml-5 mr-5`}>
        <ListPassportRenwal
          // list={data}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "CLIENT",
            "IQAMA NUMBER",
            "PASSPORT NUMBER",
            "PASSPORT EXPIRY",
            "PASSPORT ISSUE DATE",
            "NATIONALITY",
            "VALID DAYS",
            "Action",
          ]}
          token={token}
          // updateData={updateData}
          uploadFile={setShowPromptElement}
        />
      </div>
    </>
  );
}
